<ol class="step-list">
<% stepLabels.forEach(function(label, index) { %>
  <li class="step <%= index == currentStepIndex ? 'current' : (index < currentStepIndex ? 'past' : 'future') %>" data-step-index="<%= index %>">
    <span class="label"><%= label %></span>
    <span class="connector">
      <span class="connector-fill" <% if (index == currentStepIndex) { %>style="width: <%= currentStepProgress * 100 %>%"<% } %>></span>
    </span>
    <span class="status"></span>
  </li>
<% }) %>
</ol>
